export default __webpack_public_path__ + "static/media/pp-b-6.334b9545.svg";